export default "__VITE_ASSET__BSayxfUt__"